import angular from 'angular';
import addFormApp from './app-entry';
import { getHttpApi } from '@cian/http-api/browser';
import { initDependencies, setupDependencies } from './dependencies';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getStore } from '../../../shared/redux';
import { getTelemetry } from '@cian/telemetry/browser';

const DEFAULT_CPL_OFFSET = 155;
const CPL_BLOCK_NAME = '.agent-cpl-description';

setupDependencies();

initDependencies();

const config = getConfig();
const logger = getLogger();
const httpApi = getHttpApi();
const telemetry = getTelemetry();
const store = getStore();

angular.module('cian.addForm.app', [addFormApp.name])
  .constant('uibButtonConfig', {
    activeClass: 'cui-switcher__part_state_active',
    toggleEvent: 'click',
  })
  .config(['placingTermsConfig', 'addFormConfig', '$provide', function(placingTermsConfig, addFormConfig, $provide) {
    $provide.constant('config', config);
    $provide.constant('logger', logger);
    $provide.constant('httpApi', httpApi);
    $provide.constant('telemetry', telemetry);
    $provide.constant('store', store);

    const imagesPath = config.get('addformConfig.imagesPath');

    addFormConfig.imagesPath = imagesPath;
    placingTermsConfig.imagesPath = imagesPath;
  }])
  .run(['$rootScope', 'homeownerService', 'authService', 'activeDraftService', 'ngStoreToReduxMergeService',
    function($rootScope, homeownerService, authService, activeDraftService, ngStoreToReduxMergeService) {
      const { userType, userCanPublishThisOfferAsHomeowner } = homeownerService;
      const isLimitedHomeowner = userType === 'homeowner' && !userCanPublishThisOfferAsHomeowner;
      // Если есть локальный черновик, но ФП будет скрыто для ограниченного собственника, черновик удалим
      if (!window.addFormState.draft || (isLimitedHomeowner && !window.addFormState.draft.id)) {
        // Если не удалить существующий активный черновик, то при переключении на агента
        // новый черновик не сможет сохраняться, т.к. на сервере уже хранится один.
        // А не удалять нельзя, потому что поля объявления собственника могут отличаться от полей объявления агента
        if (window.addFormState.draft && window.addFormState.draft.objectGuid) {
          activeDraftService.deleteDraft(window.addFormState.draft.objectGuid);
          $rootScope.ad = {
            objectGuid: window.addFormState.draft.objectGuid,
          };
        } else {
          $rootScope.ad = {};
        }
      } else {
        $rootScope.ad = window.addFormState.draft;
      }
      $rootScope.savedAd = window.addFormState.offer || null;
      $rootScope.user = window.addFormState.user || {};
      $rootScope.regions = window.addFormState.regions || {};
      $rootScope.countryCodes = window.addFormState.countryCodes || {};

      authService.isLastStepLogin = !!window.addFormState.anonymousUserCanFillForm;

      ngStoreToReduxMergeService.subscribe();
  }]);


  // скролим к блоку "В этом жилом комплексе можно разместить объявление только по договору уступки права требования.",
  // что бы прупредить агента почему его форма не валидируется
  $( document ).ready(() => {
      const cplDescriptionElement = $(CPL_BLOCK_NAME);

      if (cplDescriptionElement.length) {
          window.scrollTo(0, cplDescriptionElement.offset().top - DEFAULT_CPL_OFFSET);
      }
  });
